import React, { forwardRef, useCallback,useImperativeHandle, useState } from "react";

import { s360ConfigService } from "../Services/S360Config";

import Custom from "./Custom";

import '../InitialForm/InitialFormStyleSheet.css';

function CheckBox(props, ref) {
  const [checkedOptions, setCheckedOptions] = useState(new Array(props.item.options.length).fill(false));

  const handleClick = (idx, lbl) => {
    console.log('label', lbl)
    let checkedArray = [...checkedOptions];
    checkedArray [idx] = (checkedArray [idx] !== true);
    // let checker = arr => arr.every(v => v === false);
    if (checkedArray[idx]) {
      document.getElementById('ch' + (props.idxx + idx)).style.fontWeight = "bold";
    } else {
      document.getElementById('ch' + (props.idxx + idx)).style.fontWeight = "normal";
    }
    // if (checker(checkedArray)) {
    //   document.getElementById(lbl).style.color = "#6c6767"
    // } else {
    //   document.getElementById(lbl).style.color = "#1b145e";
    // }
    setCheckedOptions(checkedArray);
  }

  const value = useCallback(() => {
    if (checkedOptions.length === 0) {
      return {};
    }
    let aValue = {};
    aValue[props.item.label] = checkedOptions;
    return aValue;
  }, [checkedOptions, props.item.label]);

  const validate = useCallback(() => {
    let formItemDetails = props.item || {};
    let isRequired = formItemDetails.required || formItemDetails.primaryField;
    return !(isRequired && checkedOptions.length === 0);
  }, [checkedOptions.length, props.item])

  const validationErrorMessage = useCallback(() => {
    return "Please select " + props.item.label.toLowerCase() + ".";
  }, [props.item.label])

  useImperativeHandle(ref, () => {
    return {
      value() {
        return value();
      },
      validate() {
        return validate();
      },
      validationErrorMessage() {
        return validationErrorMessage()
      }
    };
  }, [validate, validationErrorMessage, value]);

  return (
    <div className="s360-initial-form-checkbox-container" style={s360ConfigService.config?.customDesign?.initialFormCheckboxContainer} ref={ref}>
      <fieldset>
        <div className="s360-initial-form-checkbox" style={s360ConfigService.config?.customDesign?.initialFormCheckbox}>
          {props && props.item.options && props.item.options.map((eachOption, idx) => {
            return (
              <div className="s360-initial-form-checkbox-option" key={idx}>
                <Custom checked={!!checkedOptions[idx]} onChange={() => handleClick(idx, 'cb' + props.idxx)} />
                <span id={'ch' + (props.idxx + idx)} className="s360-initial-form-checkbox-label">
                  {eachOption}
                </span>
              </div>
            )
          })}
        </div>
      </fieldset>
    </div>
  );
}


export default forwardRef(CheckBox);
